<template>
  <div class="wrapper">
    <div v-for="items in tem" :key="items.index" style="margin: 15px 0px">
      <div class="title">
        <a-icon type="fire" />
        <div class="titleName">{{ items.title }}</div>
      </div>
      <div
        style="display: flex; flex-direction: row; flex-wrap: wrap; width: 100%"
      >
        <div class="content" v-for="item in items.arr" :key="item.index">
          <div class="contentTitle">{{ item.smallTitle }}</div>
          <div class="currentTem">
            实时温度:<span>{{ item.currentTem }}</span
            >°c
          </div>
          <div class="maxminTem">
            <div class="maxTem">
              <a-icon type="up" style="color: #2273c4" />上限{{ item.maxTem }}°c
            </div>
            <div class="minTem">
              <a-icon type="down" style="color: #a65861" />下限{{
                item.minTem
              }}°c
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    };
  },
  props:{
    tem:{
      type:Array
    }
  }
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  height: 450px;
  background-color: #202834;
  border-top: 2px solid #419a82;
}
.title {
  color: #a6a9b0;
  display: flex;
  align-items: center;
  padding-left: 3px;
  margin-bottom: 10px;
}
.titleName {
  color: #fff;
  font-size: 16px;
  padding-left: 7px;
}
.maxminTem {
  display: flex;
  color: #828892;
  justify-content: space-between;
  font-size: 12px;
}
.currentTem {
  color: #828892;
  font-size: 14px;
}
.currentTem span {
  color: #3778b5;
  font-size: 16px;
  padding-left: 15px;
}
.contentTitle {
  color: #fff;
}
.content {
  width: 18.5%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #1f2b40;
  padding: 5px;
  margin: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/test10Children/detailInfo.vue